import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import LazyImage from '../../Common/LazyImage';

const Image = styled(LazyImage)`
  width: 100%;
`;

export default class HoverImage extends Component {
  static propTypes = {
    src: PropTypes.string.isRequired,
    hoverSrc: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {
      src: this.props.src,
    };
  }

  mouseOver = () => {
    if (this.props.hoverSrc) {
      this.setState({ src: this.props.hoverSrc });
    }
  };

  mouseOut = () => {
    if (this.props.hoverSrc) {
      this.setState({ src: this.props.src });
    }
  };

  render() {
    return (
      <Image
        src={this.state.src}
        onMouseOver={this.mouseOver}
        onMouseOut={this.mouseOut}
      />
    );
  }
}
